import {HeaderMode, SidebarMode, ViewMode} from "../../actions/system/system.actions";


export interface IViewElementsState {
  viewMode: ViewMode;

  headerMode: HeaderMode;
  sidebarMode: SidebarMode;
  displaySize: {
    width: number;
    height: number;
  };
}

export const initialViewElementsState:IViewElementsState = {
  viewMode: 'none',

  headerMode: 'none',
  sidebarMode: 'disabled',
  displaySize: {
    width: 0,
    height: 0
  }
};
